<template>
  <Modal 
    v-model="val"
    :styles="{top: '25%'}"
    :width="600"
    @on-cancel="handleCancel"
  >
    <div class="mb-m text-center">
      <h2 class="mb-xs section-title">忘記密碼</h2>
      <p class="fz-tiny">我們將透過E-mail通知您，若還是無法找回密碼，請請撥打 (02)7707-8987 陳先生。</p>
    </div>
    <Form
      ref="forgotForm"
      label-position="left"
      :label-width="90"
      :model="model"
      :rules="rules"
      @submit.native.prevent
    >
      <BaseInput
        v-model="model.identityNo"
        label="身分證字號"
        prop="identityNo"
        type="text"
      />
      <BaseInput
        v-model="model.mail"
        label="E-mail"
        prop="mail"
        type="email"
      />
      <div class="clearfix">
        <span
          v-if="errTips"
          class="tips-primary"
          v-text="errTips"
        />
        <Button 
          class="pull-right btn-primary btn-m"
          :disabled="loading"
          :loading="loading"
          @click="handleSubmit"
        >
          <span v-if="!loading">確認送出</span>
          <span v-else>請稍候</span>
        </Button>
      </div>
    </Form>
    <div slot="footer" />
  </Modal>
</template>

<script>
  import { Modal, Form, Button } from 'iview';
  import BaseInput from '@/components/forms/elements/BaseInput';
  // validate rules
  import { identityNo, mail } from '@/utils/asyncValidator/rules';

  export default {
    components: { Modal, Form, BaseInput, Button },
    props: {
      defaultModel: {
        type: Object,
        default: () => ({
          identityNo: '',
          mail: ''
        })
      },
      value: {
        type: Boolean,
        default: false
      },
      loading: {
        type: Boolean,
        default: false
      },
      handleForgotReq: {
        type: Function,
        default: () => {}
      }
    },
    data() {
      return {
        rules: { identityNo, mail },
        model: { ...this.defaultModel },
        errTips: null
      };
    },
    computed: {
      val: {
        get() { return this.value; },
        set(val) { this.$emit('input', val); }
      }
    },
    methods: {
      async handleSubmit() {
        const { model, $refs } = this;
        const isValid = await $refs.forgotForm.validate(v => v);
        if (!isValid) return;
        const err = await this.handleForgotReq(model);
        if (err) {
          this.errTips = err;
          return;
        }
        this.errTips = null;
        this.$emit('input', false);
      },
      handleCancel() {
        const { $refs: { forgotForm } } = this;
        this.errTips = null;
        forgotForm.resetFields();
      }
    }
  };
</script>